
































































import { Component, Vue } from "vue-property-decorator";

interface Iform {
  username?: unknown | string;
  password?: unknown | string;
  password2?: unknown | string;
  checked?: boolean;
  checked2?: boolean;
}

@Component({
  components: {}
})
export default class Home extends Vue {
  private login = false;
  private form: Iform = {};

  private onClick() {
    this.login = !this.login;

    const setform: Iform = {
      username: null,
      password: null,
      password2: null,
      checked: false,
      checked2: false
    };

    this.form = setform;
  }

  submit() {
    // console.log(this.form);
  }
}
